import React from 'react';
import dayjs from 'dayjs';
import { TableColumnsType } from 'antd';
import { IPromouter } from '@api/services/bookingApi/types';
import * as S from './styles';
import StatusSelector from '../StatusSelector/StatusSelector';
import { IBookingObj } from '@types';

interface GetBookingColumnsProps {
    handleRowClick: (record: any, e: React.MouseEvent) => void;
    handlerClickId: (
        id: number,
        e: React.MouseEvent<HTMLSpanElement, MouseEvent>
    ) => void;
    getColumnSearchProps: (dataIndex: string) => any;
    searchText: string;
}

export const getBookingColumns = ({
    handleRowClick,
    handlerClickId,
    getColumnSearchProps,
    searchText,
}: GetBookingColumnsProps): TableColumnsType<IBookingObj> => {
    return [
        {
            title: '№',
            width: 40,
            render: (record: IBookingObj) => (
                <S.StyledLink
                    onClick={e => handleRowClick(record, e)}
                    role="button"
                    tabIndex={0}
                >
                    {record.id}
                </S.StyledLink>
            ),
        },
        {
            title: 'Дата',
            width: 80,
            render: (record: IBookingObj) => {
                return (
                    <span>
                        {record && record.bookingStart
                            ? dayjs(record.bookingStart).format('DD.MM.YYYY')
                            : '-'}
                    </span>
                );
            },
        },
        {
            title: 'Время',
            width: 80,
            render: (record: IBookingObj) => {
                return (
                    <span>
                        {record && record.bookingStart
                            ? dayjs(record.bookingStart).format('HH:mm')
                            : '-'}
                    </span>
                );
            },
        },
        {
            title: 'Имя',
            dataIndex: 'personName',
            width: 140,
            sorter: (a, b) =>
                a.personName && b.personName
                    ? a.personName.localeCompare(b.personName)
                    : 0,
            ...getColumnSearchProps('personName'),
        },
        {
            title: 'Телефон',
            dataIndex: 'personPhone',
            width: 130,
            sorter: (a, b) =>
                (a.personPhone || '').localeCompare(b.personPhone || ''),
            ...getColumnSearchProps('personPhone'),
            render: (phone: string, record: IBookingObj) =>
                !record?.client_id ? (
                    <S.TextWrapper>{phone}</S.TextWrapper>
                ) : (
                    <S.StyledLink
                        onClick={e => handlerClickId(record.client_id!, e)}
                        role="button"
                        tabIndex={0}
                    >
                        {phone}
                    </S.StyledLink>
                ),
        },
        {
            title: 'К-во гостей',
            dataIndex: 'guestsCount',
            width: 110,
            sorter: (a, b) => (a.guestsCount || 0) - (b.guestsCount || 0),
            ...getColumnSearchProps('guestsCount'),
        },
        {
            title: 'Помещение',
            width: 110,
            render: (record: IBookingObj) => {
                return (
                    <S.StyledRoseSpan>
                        {record.hall?.name ? record.hall.name : 'не выбрано'}
                    </S.StyledRoseSpan>
                );
            },
        },
        {
            title: '№ стола',
            width: 110,
            render: (record: IBookingObj) => {
                return (
                    <S.StyledRoseSpan>
                        {record.table?.name ? record.table.name : 'не выбран'}
                    </S.StyledRoseSpan>
                );
            },
        },
        {
            title: 'Стоимость',
            width: 90,
            render: (record: IBookingObj) => (
                <>
                    {record && record.prePaid ? (
                        <S.Sspan>
                            {new Intl.NumberFormat('ru-RU', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }).format(Number(record.prePaid))}
                        </S.Sspan>
                    ) : (
                        <span>-</span>
                    )}
                    /
                    {record && record.table && record.table.price ? (
                        <S.Nspan>
                            {new Intl.NumberFormat('ru-RU', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }).format(Number(record.table.price))}
                        </S.Nspan>
                    ) : (
                        <span>-</span>
                    )}
                </>
            ),
        },
        {
            title: 'Промо',
            dataIndex: 'promouter',
            width: 110,
            render: (promouter: IPromouter) => {
                return promouter ? <>{promouter.firstName}</> : <></>;
            },
        },
        {
            title: 'Статус',
            width: 110,
            render: (record: IBookingObj) => {
                switch (record.status) {
                    case 'declined':
                        return (
                            <S.StyledNotAcceptedLabel>
                                <span>Отклонено</span>
                            </S.StyledNotAcceptedLabel>
                        );
                    case 'approved':
                        return (
                            <S.StyledAcceptedLabel>
                                <span>Подтверждено</span>
                            </S.StyledAcceptedLabel>
                        );
                    case 'complete':
                        return (
                            <S.StyledCompletedLabel>
                                <span>Завершено</span>
                            </S.StyledCompletedLabel>
                        );
                    case 'canceled':
                        return (
                            <S.StyledNotAcceptedLabel>
                                <span>Отказ</span>
                            </S.StyledNotAcceptedLabel>
                        );
                    default:
                        return <StatusSelector record={record} />;
                }
            },
        },
    ];
};
